<div class="contacts-container mt-4">
    <div class="d-grid contacts-header">
        <div class="d-flex align-items-center contact-title-wrapper">
            <img src="assets/svg/money-icon.svg" width="20" class="contact-section-icon">
            <h3 class="text-semibold contact-title">Historial del presupuestos</h3>
        </div>
    </div>

    <div class="prospectos-table  mt-3">
        <table class="stage-history-table">
            <thead>
                <tr>
                    <th>
                        <div class="th-content">
                            <span>nombre</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>N° de presupuesto</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Probabilidad(%)</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Fecha de ultima modificacion</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Última modificacio</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>
                    <th>
                        <div class="th-content">
                            <span>Total presupuesto</span>
                            <img src="assets/svg/arrow-down-black.svg" class="sort-icon">
                        </div>
                    </th>

                </tr>
            </thead>
            <tbody>
                <tr *ngFor=" let v of versiones.slice(0,10)">
                <td>
                <div class="d-flex flex-row align-items-center color-org">
                <u>{{v?.cambio_descripcion}}</u>
                </div>
            </td>
            <td>{{ v.cabecera?.presupuesto_id }}</td>
            <td>{{ v.cabecera?.probabilidad || 0 }}%</td>
            <td>{{ v.fecha_creacion | date:'dd/MM/yyyy HH:mm' }}</td>
            <td>{{ v.modificado_por?.nombre }} {{ v.modificado_por?.apellido }}</td>
            <td>
            {{ v.cabecera?.totales?.precio_total | currency:'CLP ' }}
            </td>
                </tr>
                <tr class="view-all-row">
                    <td colspan="6" class="text-center">
                        <button class="btn btn-link color-org" 
                        [routerLink]="['/budget', presupuesto_id, 'budget-version-table']"
                        style="width: 125px; height: 32px; border-radius: 32px; border: 1px solid; background-color: white;"  value="detail" >
                            Ver todos
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
